import { useEffect, useState } from 'react';
import st from './index.module.scss';

const ProfessionalServicesAnimation = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prevIndex => (prevIndex + 1) % 4);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`${st['animation-group']} grid place-items-center w-[1027px] h-[1027px] absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 `}
    >
      <div
        className={`md:w-[368px] md:h-[368px] w-[335px] h-[335px] border-[#0052b4] transition-opacity duration-[2000ms] ease-in-out absolute z-10 ${activeIndex === 0 ? 'opacity-100' : 'opacity-0'}`}
      ></div>
      <div className={`md:w-[368px] md:h-[368px] w-[335px] h-[335px] border-white absolute z-1`}></div>
      <div
        className={`md:w-[617px] md:h-[617px] h-[563px] w-[563px] border-[#d9a8e5] transition-opacity duration-[2000ms] ease-in-out absolute z-10 ${activeIndex === 1 ? 'opacity-100' : 'opacity-0'}`}
      ></div>
      <div className={`md:w-[617px] md:h-[617px] h-[563px] w-[563px] border-white absolute z-1`}></div>
      <div
        className={`md:w-[816px] md:h-[816px] w-[745px] h-[745px] border-[#f79e1b] transition-opacity duration-[2000ms] ease-in-out absolute z-10 ${activeIndex === 2 ? 'opacity-100' : 'opacity-0'}`}
      ></div>
      <div className={`md:w-[816px] md:h-[816px] w-[745px] h-[745px] border-white absolute z-1`}></div>
      <div
        className={`md:w-[1027px] md:h-[1027px] border-[#ff4b55] transition-opacity duration-[2000ms] ease-in-out absolute z-10 ${activeIndex === 3 ? 'opacity-100' : 'opacity-0'}`}
      ></div>
      <div className={`md:w-[1027px] md:h-[1027px] border-white absolute z-1`}></div>
    </div>
  );
};

export default ProfessionalServicesAnimation;
